import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import * as Editor from '../../../../../assets/ckeditor/build/ckeditor';
import { AdminService } from '../../../../shared/services/admin.service';
import { InteractiveCasesService } from '../../../../ccs/ccs-module/services/interactive-cases.service';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'app-case-management',
  templateUrl: './case-management.component.html',
  styleUrls: ['./case-management.component.scss']
})
export class CaseManagementComponent implements OnInit, OnDestroy {

  // Tab management
  activeTab: 'cases' | 'orders' = 'cases';

  // Cases data
  cases: any[] = [];
  filteredCases: any[] = [];
  
  // Orders data
  orders: any[] = [];
  filteredOrders: any[] = [];
  orderCategories: any[] = [];
  orderTypes: any[] = [];
  prerequisiteOrders: any[] = [];
  
  // Physical evaluations data
  physicalEvaluations: any[] = [];
  
  // Forms
  caseForm: FormGroup;
  orderForm: FormGroup;
  categoryForm: FormGroup;
  typeForm: FormGroup;
  
  // Modal states
  showCaseModal: boolean = false;
  isCaseModalOpen = false;
  isEditingCase = false;
  modalType: 'add' | 'edit' = 'add';
  currentCaseId = '';
  modalLoader: boolean = false;
  
  // Order management modal states
  showOrderModal: boolean = false;
  showCategoryModal: boolean = false;
  showTypeModal: boolean = false;
  orderModalType: 'add' | 'edit' = 'add';
  categoryModalType: 'add' | 'edit' = 'add';
  typeModalType: 'add' | 'edit' = 'add';
  currentOrderId = '';
  currentCategoryId = '';
  currentTypeId = '';
  
  // Delete confirmation modal
  showDeleteConfirmModal: boolean = false;
  itemToDelete: any = null;
  deleteType: 'case' | 'order' | 'category' | 'type' = 'case';
  deleteErrorMessage: string = '';

  // Loading and search
  loading = false;
  orderSearchTerm: string = '';
  searchTerm: string = '';

  // Order management active sub-tab
  orderActiveTab: 'orders' | 'categories' | 'types' = 'orders';

  // Route/Urgency selection tracking
  selectedRouteUrgType: number = 0; // Track primary dropdown selection
  showSecondaryDropdown: boolean = false;
  secondaryDropdownLabel: string = '';
  secondaryDropdownOptions: any[] = [];

  // Custom notification system
  notification = {
    show: false,
    message: '',
    type: 'success' as 'success' | 'error'
  };

  // CKEditor instances
  ckEditorIntroduction: any;
  ckEditorHistory: any;
  ckEditorExplanation: any;
  ckEditorOrderResponse: any; // New CKEditor instance for order response

  // Explanation modal properties
  showExplanationModal: boolean = false;
  explanationModalType: 'add' | 'edit' = 'add';
  currentExplanationCase: any = null;
  explanationForm: FormGroup;
  
  // CKEditor instances for explanation
  ckEditorApproach: any;
  ckEditorScoring: any;
  ckEditorClockManagement: any;

  // Return Time simulation properties (similar to launch-case component)
  simulationTime = {
    days: 0,
    hours: 0,
    minutes: 0
  };

  // Add routine return time simulation properties
  routineSimulationTime = {
    days: 0,
    hours: 0,
    minutes: 0
  };

  currentDayOfWeek: string = '';
  showTimeSpinners: boolean = false;

  // frequency list 
  frequencyList = [
    {
        "id": 0,
        "type": "N/A"
    },
    {
        "id": 1,
        "type": "Continuous"
    },
    {
        "id": 2,
        "type": "Every X"
    },
    {
        "id": 3,
        "type": "One Time/Bolus"
    }
]

  //urgency/rotue options 
  
routeUrgCodes = 
  [
    {"id": 0,"value": "N/A"},
    { "id": 1,"value": "Route"},
    {"id": 2,"value": "Urgency"},

  ]


  // ungencry array
  urgCodes = [
    {
        "id": 0,
        "type": "N/A",
        "reportTime": "0"
    },
    {
        "id": 1,
        "type": "Routine",
        "reportTime": "8"
    },
    {
        "id": 2,
        "type": "Stat",
        "reportTime": "4"
    }
]


//routes array  
routeCodes = [
  {
      "id": 0,
      "type": "N/A",
      "abbr": "N/A"
  },
  {
      "id": 1,
      "type": "Epidural",
      "abbr": "ED"
  },
  {
      "id": 2,
      "type": "IntraArticular",
      "abbr": "IA"
  },
  {
      "id": 3,
      "type": "IntraMuscular",
      "abbr": "IM"
  },
  {
      "id": 4,
      "type": "Intravenous",
      "abbr": "IV"
  },
  {
      "id": 5,
      "type": "Inhalation",
      "abbr": "IN"
  },
  {
      "id": 6,
      "type": "opthalmic",
      "abbr": "OP"
  },
  {
      "id": 7,
      "type": "Oral",
      "abbr": "PO"
  },
  {
      "id": 8,
      "type": "Otic",
      "abbr": "OT"
  },
  {
      "id": 9,
      "type": "Rectal",
      "abbr": "RE"
  },
  {
      "id": 10,
      "type": "Subcutaneous",
      "abbr": "SC"
  },
  {
      "id": 11,
      "type": "Sublingual",
      "abbr": "SL"
  },
  {
      "id": 12,
      "type": "Topical",
      "abbr": "TP"
  },
  {
      "id": 13,
      "type": "Vaginal",
      "abbr": "VA"
  }
]
  // Location options
  locationOptions = [
    { value: 'Office', label: 'Office' },
    { value: 'Home', label: 'Home' },
    { value: 'Intensive Care Unit', label: 'Intensive Care Unit' },
    { value: 'Emergency', label: 'Emergency' },
    { value: 'Inpatient Unit', label: 'Inpatient Unit' }
  ];

  // CKEditor instances for linked order custom responses
  ckEditorLinkedOrderResponses: any[] = []; // Array to store CKEditor instances for each linked order
  
  // Track which CKEditor instances need initialization after view updates
  pendingCKEditorInitializations: Set<number> = new Set();

  constructor(
    private adminService: AdminService,
    private interactiveCasesService: InteractiveCasesService,
    private formBuilder: FormBuilder
  ) {
    this.initializeCaseForm();
    this.initializeOrderForms();
    this.initializeExplanationForm();
  }

  ngOnInit(): void {
    this.loadCases();
    this.loadOrders();
    this.loadOrderCategories();
    this.loadOrderTypes();
    this.loadPhysicalEvaluations();
  }

  ngOnDestroy(): void {
    // Destroy CKEditor instances when component is destroyed
    this.destroyCKEditorInstances();
    this.destroyExplanationCKEditors();
    this.destroyLinkedOrderResponseCKEditors(); // Add cleanup for linked order CKEditors
  }

  initializeCaseForm(): void {
    this.caseForm = this.formBuilder.group({
      // Initial case details
      specialty: ['', Validators.required],
      subSpecialty: ['', Validators.required],
      location: ['', Validators.required],
      duration: [0, [Validators.required, Validators.min(1)]],
      
      // Pre-existing orders
      preOrders: [[]],
      
      // Maximum simulated time
      maxSimulatedTime: [0, [Validators.required, Validators.min(0)]],
      
      // Case details
      introduction: [''],
      initialHistory: [''],
      baselineVitals: this.formBuilder.group({
        temperature: [0, Validators.required],
        pulse: [0, Validators.required],
        pulseQuality: ['Regular', Validators.required],
        respiratoryRate: [0, Validators.required],
        systolicBP: [0, Validators.required],
        diastolicBP: [0, Validators.required],
        height: [0, Validators.required],
        weight: [0, Validators.required],
        bmi: [0, Validators.required]
      }),
      caseDay: [1, [Validators.required, Validators.min(1)]],
      caseTime: ['', [Validators.required, Validators.pattern(/^\d{4}$/)]],
      
      // Case conditions (dynamic array)
      conditions: this.formBuilder.array([]),
      
      // Interval/Follow-up (dynamic array)
      intervals: this.formBuilder.array([]),
      
      // Physical evaluations
      physicalEvaluations: this.formBuilder.group({}),
      
      // Linked Orders (dynamic array)
      linkedOrders: this.formBuilder.array([]),
      
      // Case explanation
      explanation: ['']
    });
  }

  initializeOrderForms(): void {
    // Order form
    this.orderForm = this.formBuilder.group({
      orderName: ['', Validators.required],
      orderCategory: ['', Validators.required],
      orderType: ['', Validators.required],
      frequencyVal: [[]],
      response: [''],
      prerequisiteOrder: [[]],
      routeUrgencyType: [0], // Primary dropdown selection
      routeUrgencyId: 0, // Changed to array
      routeUrgencyVal: [], // Changed to array
      orderDay: [0],
      orderReturnTime: [''],
      routineOrderReturnTime: [''] // Add new field for routine return time
    });

    // Category form
    this.categoryForm = this.formBuilder.group({
      name: ['', Validators.required]
    });

    // Type form
    this.typeForm = this.formBuilder.group({
      type: ['', Validators.required]
    });
  }

  initializeExplanationForm(): void {
    this.explanationForm = this.formBuilder.group({
      explanation: ['']
    });
  }

  get conditionsArray(): FormArray {
    return this.caseForm.get('conditions') as FormArray;
  }

  get intervalsArray(): FormArray {
    return this.caseForm.get('intervals') as FormArray;
  }

  get linkedOrdersArray(): FormArray {
    return this.caseForm.get('linkedOrders') as FormArray;
  }

  createConditionGroup(): FormGroup {
    return this.formBuilder.group({
      day: [1, [Validators.required, Validators.min(1)]],
      time: ['', [Validators.required, Validators.pattern(/^\d{4}$/)]],
      description: ['', Validators.required],
      linkedOrders: [[]],
      conditionType: [1, Validators.required] // 1 = Positive, 0 = Negative
    });
  }

  createIntervalGroup(): FormGroup {
    return this.formBuilder.group({
      day: [1, [Validators.required, Validators.min(1)]],
      time: ['', [Validators.required, Validators.pattern(/^\d{4}$/)]],
      description: ['', Validators.required],
      conditionType: [1, Validators.required] // 1 = Positive, 0 = Negative
    });
  }

  createLinkedOrderGroup(): FormGroup {
    return this.formBuilder.group({
      // Original order structure
      id: ['', Validators.required],
      orderName: ['', Validators.required],
      orderCategory: [''],
      orderType: [''],
      orderDay: [0],
      orderReturnTime: [''],
      routineOrderReturnTime: [''],
      name: [''],
      category_description: [''],
      frequencyVal: [], // Changed to array for multiselect
      prerequisiteOrder: [[]],
      response: [''],
      routeUrgencyType: [0], // Primary dropdown selection
      routeUrgencyId: 0, // Changed to array
      routeUrgencyVal: [], // Changed to array
      type: [''],
      // New custom response field
      customResponse: ['', Validators.required]
    });
  }

  addCondition(): void {
    this.conditionsArray.push(this.createConditionGroup());
  }

  removeCondition(index: number): void {
    this.conditionsArray.removeAt(index);
  }

  addInterval(): void {
    this.intervalsArray.push(this.createIntervalGroup());
  }

  removeInterval(index: number): void {
    this.intervalsArray.removeAt(index);
  }

  addLinkedOrder(): void {
   
    const formData = this.prepareCaseData();

    
    this.linkedOrdersArray.push(this.createLinkedOrderGroup());
    
    // Initialize CKEditor for the new linked order after view updates
    setTimeout(() => {
      const newOrderIndex = this.linkedOrdersArray.length - 1;
      this.initializeLinkedOrderResponseCKEditor(newOrderIndex, '');
    }, 100);
  }

  removeLinkedOrder(index: number): void {
    // Destroy CKEditor instance for the order being removed
    if (this.ckEditorLinkedOrderResponses[index]) {
      this.ckEditorLinkedOrderResponses[index].destroy();
      this.ckEditorLinkedOrderResponses[index] = null;
    }
    
    this.linkedOrdersArray.removeAt(index);
    
    // Remove the editor from array and shift remaining editors
    this.ckEditorLinkedOrderResponses.splice(index, 1);
    
    // Re-initialize remaining CKEditor instances with correct indices after DOM updates
    setTimeout(() => {
      for (let i = index; i < this.linkedOrdersArray.length; i++) {
        const linkedOrderGroup = this.linkedOrdersArray.at(i);
        if (linkedOrderGroup) {
          const content = linkedOrderGroup.get('customResponse')?.value || '';
          this.initializeLinkedOrderResponseCKEditor(i, content);
        }
      }
    }, 100);
  }

  onOrderSelect(orderIndex: number, event: any): void {
    const selectedOrderId = event.target.value;
    
    
    const linkedOrderGroup = this.linkedOrdersArray.at(orderIndex) as FormGroup;
    
    if (selectedOrderId) {
      // Find the selected order by ID
      const selectedOrder = this.orders.find(o => o.id == selectedOrderId);
      
      if (selectedOrder) {
        // Parse prerequisiteOrder if it's a JSON string, otherwise use as array
        let prerequisiteOrderArray = [];
        if (selectedOrder.prerequisiteOrder) {
          if (typeof selectedOrder.prerequisiteOrder === 'string') {
            try {
              prerequisiteOrderArray = JSON.parse(selectedOrder.prerequisiteOrder);
            } catch (e) {
              // If parsing fails, treat as single ID and convert to array
              prerequisiteOrderArray = [selectedOrder.prerequisiteOrder];
            }
          } else if (Array.isArray(selectedOrder.prerequisiteOrder)) {
            prerequisiteOrderArray = selectedOrder.prerequisiteOrder;
          } else {
            // Single value, convert to array
            prerequisiteOrderArray = [selectedOrder.prerequisiteOrder];
          }
        }

        // Populate all original order fields
        linkedOrderGroup.patchValue({
          id: selectedOrder.id,
          orderName: selectedOrder.orderName || '',
          orderCategory: selectedOrder.orderCategory || '',
          orderType: selectedOrder.orderType || '',
          orderDay: selectedOrder.orderDay || 0,
          orderReturnTime: selectedOrder.orderReturnTime || '',
          routineOrderReturnTime: selectedOrder.routineOrderReturnTime || '',
          name: selectedOrder.name || '',
          category_description: selectedOrder.category_description || '',
          frequencyVal: selectedOrder.frequencyVal || [],
          prerequisiteOrder: prerequisiteOrderArray,
          response: selectedOrder.response || '',
          routeUrgencyType: selectedOrder.routeUrgencyType || 0,
          routeUrgencyId: selectedOrder.routeUrgencyId || 0,
          routeUrgencyVal: selectedOrder.routeUrgencyVal || [],
          type: selectedOrder.type || ''
        });
      
      }
    } else {
      // Clear the form if no order is selected
      linkedOrderGroup.patchValue({
        id: '',
        orderName: '',
        orderCategory: '',
        orderType: '',
        orderDay: 0,
        orderReturnTime: '',
        routineOrderReturnTime: '',
        name: '',
        category_description: '',
        frequencyVal: [],
        prerequisiteOrder: [],
        response: '',
        routeUrgencyType: 0,
        routeUrgencyId: 0,
        routeUrgencyVal: [],
        type: ''
      });
    }
  }

  // Handle PrimeNG dropdown onChange event for order selection
  onOrderSelectDropdown(event: any, orderIndex: number): void {
    const selectedOrderId = event.value;
    
    const linkedOrderGroup = this.linkedOrdersArray.at(orderIndex) as FormGroup;
    
    if (selectedOrderId) {
      // Find the selected order by ID
      const selectedOrder = this.orders.find(o => o.id == selectedOrderId);
      
      if (selectedOrder) {
        // Parse prerequisiteOrder if it's a JSON string, otherwise use as array
        let prerequisiteOrderArray = [];
        if (selectedOrder.prerequisiteOrder) {
          if (typeof selectedOrder.prerequisiteOrder === 'string') {
            try {
              prerequisiteOrderArray = JSON.parse(selectedOrder.prerequisiteOrder);
            } catch (e) {
              // If parsing fails, treat as single ID and convert to array
              prerequisiteOrderArray = [selectedOrder.prerequisiteOrder];
            }
          } else if (Array.isArray(selectedOrder.prerequisiteOrder)) {
            prerequisiteOrderArray = selectedOrder.prerequisiteOrder;
          } else {
            // Single value, convert to array
            prerequisiteOrderArray = [selectedOrder.prerequisiteOrder];
          }
        }

        // Populate all original order fields
        linkedOrderGroup.patchValue({
          id: selectedOrder.id,
          orderName: selectedOrder.orderName || '',
          orderCategory: selectedOrder.orderCategory || '',
          orderType: selectedOrder.orderType || '',
          orderDay: selectedOrder.orderDay || 0,
          orderReturnTime: selectedOrder.orderReturnTime || '',
          routineOrderReturnTime: selectedOrder.routineOrderReturnTime || '',
          name: selectedOrder.name || '',
          category_description: selectedOrder.category_description || '',
          frequencyVal: selectedOrder.frequencyVal || [],
          prerequisiteOrder: prerequisiteOrderArray,
          response: selectedOrder.response || '',
          routeUrgencyType: selectedOrder.routeUrgencyType || 0,
          routeUrgencyId: selectedOrder.routeUrgencyId || 0,
          routeUrgencyVal: selectedOrder.routeUrgencyVal || [],
          type: selectedOrder.type || ''
        });
      
      }
    } else {
      // Clear the form if no order is selected
      linkedOrderGroup.patchValue({
        id: '',
        orderName: '',
        orderCategory: '',
        orderType: '',
        orderDay: 0,
        orderReturnTime: '',
        routineOrderReturnTime: '',
        name: '',
        category_description: '',
        frequencyVal: [],
        prerequisiteOrder: [],
        response: '',
        routeUrgencyType: 0,
        routeUrgencyId: 0,
        routeUrgencyVal: [],
        type: ''
      });
    }
  }

  // Tab management
  switchTab(tab: 'cases' | 'orders'): void {
    this.activeTab = tab;
  }

  // Route/Urgency dropdown handling methods
  onRouteUrgencyTypeChange(selectedValue: number): void {
    this.selectedRouteUrgType = selectedValue;

   
    
    // Reset secondary dropdown values
    this.orderForm.patchValue({
      routeUrgencyId: 0,
      routeUrgencyVal: []
    });

    // Configure secondary dropdown based on selection
    switch (selectedValue) {
      case 0: // N/A
        this.showSecondaryDropdown = false;
        this.secondaryDropdownLabel = '';
        this.secondaryDropdownOptions = [];
        // Save empty arrays for N/A
        this.orderForm.patchValue({
          routeUrgencyId: 0,
          routeUrgencyVal: []
        });
        break;
        
      case 1: // Route
        this.showSecondaryDropdown = true;
        this.secondaryDropdownLabel = 'Select Route';
        // Prepare route options with display labels for PrimeNG
        this.secondaryDropdownOptions = this.routeCodes.map(route => ({
          ...route,
          displayLabel: `${route.type} (${route.abbr})`
        }));
     
        // Set routeUrgencyId to [1] to indicate Route was selected
        this.orderForm.patchValue({
          routeUrgencyId: 1
        });
        break;
        
      case 2: // Urgency
        this.showSecondaryDropdown = true;
        this.secondaryDropdownLabel = 'Select Urgency';
        this.secondaryDropdownOptions = this.urgCodes;
        
        // Set routeUrgencyId to [2] to indicate Urgency was selected
        this.orderForm.patchValue({
          routeUrgencyId: 2
        });
        break;
        
      default:
        this.showSecondaryDropdown = false;
        this.secondaryDropdownLabel = '';
        this.secondaryDropdownOptions = [];
        break;
    }
    
  }

  // Helper method to initialize dropdown state when editing
  initializeRouteUrgencyDropdowns(orderData: any): void {

    
    
    if (orderData.routeUrgencyType !== undefined) {
      this.selectedRouteUrgType = orderData.routeUrgencyType;
      this.onRouteUrgencyTypeChange(orderData.routeUrgencyType);
      
      // Immediately restore the selected values after configuring the dropdown
      if (orderData.routeUrgencyVal && Array.isArray(orderData.routeUrgencyVal)) {
        this.orderForm.patchValue({
          routeUrgencyVal: orderData.routeUrgencyVal
        });
      }
    } else if (orderData.routeUrgencyId ) {
      // Legacy data handling - determine type from routeUrgencyId
      const firstId = orderData.routeUrgencyId;
      if (firstId === '1' || firstId === 1) {
        this.selectedRouteUrgType = 1; // Route
        this.onRouteUrgencyTypeChange(1);
      } else if (firstId === '2' || firstId === 2) {
        this.selectedRouteUrgType = 2; // Urgency
        this.onRouteUrgencyTypeChange(2);
      }
      
      // Immediately restore the selected values after configuring the dropdown
      if (orderData.routeUrgencyVal && Array.isArray(orderData.routeUrgencyVal)) {
        this.orderForm.patchValue({
          routeUrgencyVal: orderData.routeUrgencyVal
        });
      }
    }
  }

  // Data loading methods
  loadCases(): void {
    this.loading = true;
    this.interactiveCasesService.getInteractiveCases().subscribe({
      next: (response: any) => {
     
        this.cases = response || [];
        this.filteredCases = this.cases;
        this.loading = false;
      },
      error: (error) => {
       
        this.showNotification('Error loading cases', 'error');
        this.loading = false;
      }
    });
  }

  loadOrders(): void {
    this.adminService.getOrders().subscribe({
      next: (response: any) => {
        if (response.success) {
          this.orders = response.data;

          // Parse JSON strings for frequency, route/urgency values, and prerequisite orders for all orders
          for (let item of this.orders) {
            // Parse frequencyVal if it's a string
            if (typeof item.frequencyVal === 'string' && item.frequencyVal) {
              try {
                item.frequencyVal = JSON.parse(item.frequencyVal);
              } catch (e) {
                 
                item.frequencyVal = [];
              }
            } else if (!Array.isArray(item.frequencyVal)) {
              item.frequencyVal = [];
            }

            // Parse routeUrgencyVal if it's a string
            if (typeof item.routeUrgencyVal === 'string' && item.routeUrgencyVal) {
              try {
                item.routeUrgencyVal = JSON.parse(item.routeUrgencyVal);
              } catch (e) {
                 
                item.routeUrgencyVal = [];
              }
            } else if (!Array.isArray(item.routeUrgencyVal)) {
              item.routeUrgencyVal = [];
            }

            // Parse prerequisiteOrder if it's a string
            if (typeof item.prerequisiteOrder === 'string' && item.prerequisiteOrder) {
              try {
                item.prerequisiteOrder = JSON.parse(item.prerequisiteOrder);
              } catch (e) {
                // If parsing fails, treat as single ID and convert to array
                item.prerequisiteOrder = item.prerequisiteOrder ? [item.prerequisiteOrder] : [];
              }
            } else if (!Array.isArray(item.prerequisiteOrder)) {
              item.prerequisiteOrder = item.prerequisiteOrder ? [item.prerequisiteOrder] : [];
            }
          }

          this.filteredOrders = this.orders;
        } else {
          this.showNotification('Error loading orders', 'error');
        }
      },
      error: (error) => {
        console.error('Error loading orders:', error);
        this.showNotification('Error loading orders', 'error');
      }
    });
  }

  loadOrderCategories(): void {
    this.adminService.getOrderCategories().subscribe({
      next: (response: any) => {
        if (response.success) {
          this.orderCategories = response.data;
        }
      },
      error: (error) => {
        console.error('Error loading order categories:', error);
      }
    });
  }

  loadOrderTypes(): void {
    this.adminService.getOrderTypes().subscribe({
      next: (response: any) => {
        if (response.success) {
          this.orderTypes = response.data;
        }
      },
      error: (error) => {
        console.error('Error loading order types:', error);
      }
    });
  }

  loadPhysicalEvaluations(): void {
    this.adminService.getPhysicalEvaluations().subscribe({
      next: (response: any) => {
       
        this.physicalEvaluations = response;
        this.initializePhysicalEvaluationControls();
      },
      error: (error) => {
        console.error('Error loading physical evaluations:', error);
        this.showNotification('Error loading physical evaluations', 'error');
      }
    });
  }

  initializePhysicalEvaluationControls(): void {
    const physicalEvaluationsGroup = this.caseForm.get('physicalEvaluations') as FormGroup;
    
    this.physicalEvaluations.forEach(evaluation => {
      physicalEvaluationsGroup.addControl(
        `evaluation_${evaluation.id}`, 
        this.formBuilder.control('')
      );
    });
  }

  // Case management methods
  openCaseModal(type: 'add' | 'edit', caseData?: any): void {


    this.modalType = type;
   
    this.isCaseModalOpen = true;
    
    if (type === 'edit' && caseData) {
      this.isEditingCase = true;
      this.currentCaseId = caseData.id;
      this.loading=true;
      // Show loading state
      this.modalLoader = true;

      // Fetch detailed case data from API
      this.interactiveCasesService.getCaseById(caseData.id).subscribe({
        next: (detailedCaseData: any) => {
          
          this.modalLoader = false;
          
          // Populate form with detailed data
          this.populateCaseForm(detailedCaseData);
          
          // Initialize CKEditor instances after data is loaded
          setTimeout(() => this.initializeCKEditors(detailedCaseData), 100);
          this.loading=false;
          this.showCaseModal = true;
        },
        error: (error) => {
          console.error('Error fetching case details:', error);
          this.modalLoader = false;
          this.showNotification('Error loading case details', 'error');
          
          // Fallback to using the limited table data
          this.populateCaseForm(caseData);
          setTimeout(() => this.initializeCKEditors(caseData), 100);
          this.loading=false;
          this.showCaseModal = true;
          
        }
      });
    } else {
     
          this.showCaseModal = true;
      this.isEditingCase = false;
      this.currentCaseId = '';
      this.resetCaseForm();
      
      // Initialize CKEditor instances after modal opens
      setTimeout(() => this.initializeCKEditors(), 100);
    }
  }

  populateCaseForm(caseData: any): void {
    // Parse preOrders if it's a string
    let preOrdersArray = [];
    if (caseData.preOrders) {
      if (typeof caseData.preOrders === 'string') {
        try {
          preOrdersArray = JSON.parse(caseData.preOrders);
        } catch (e) {
          preOrdersArray = [caseData.preOrders];
        }
      } else if (Array.isArray(caseData.preOrders)) {
        preOrdersArray = caseData.preOrders;
      }
    }



    caseData.case_conditions = JSON.parse(caseData.case_conditions)
    caseData.baseline_vitals = JSON.parse(caseData.baseline_vitals)
    this.caseForm.patchValue({
      specialty: caseData.specialty || '',
      subSpecialty: caseData.sub_specialty || '',
      location: caseData.location || '',
      duration: caseData.estimated_duration || 0,
      preOrders: preOrdersArray,
      maxSimulatedTime: caseData.maxSimulatedTime || 0,
      introduction: caseData.introduction || '',
      initialHistory: caseData.past_medical_history || '',
      baselineVitals: caseData.baseline_vitals || {},
      caseDay: caseData.case_day || 1,
      caseTime: caseData.case_Time || '',
      explanation: '' // Will be populated from CKEditor
    });

    // Populate conditions
    this.conditionsArray.clear();
    if (caseData.case_conditions && Array.isArray(caseData.case_conditions)) {
      caseData.case_conditions.forEach((condition: any) => {
        const conditionGroup = this.createConditionGroup();
        conditionGroup.patchValue({
          day: condition.day || 1,
          time: condition.time || '',
          description: condition.description || '',
          linkedOrders: condition.linkedOrders || [],
          conditionType: condition.conditionType !== undefined ? condition.conditionType : 1
        });
        this.conditionsArray.push(conditionGroup);
      });
    }

    // Populate intervals
    this.intervalsArray.clear();
    if (caseData.patient_interval) {
      let intervalData = [];
      if (typeof caseData.patient_interval === 'string') {
        try {
          intervalData = JSON.parse(caseData.patient_interval);
        } catch (e) {
          console.error('Error parsing patient_interval:', e);
          intervalData = [];
        }
      } else if (Array.isArray(caseData.patient_interval)) {
        intervalData = caseData.patient_interval;
      }
      
      if (Array.isArray(intervalData)) {
        intervalData.forEach((interval: any) => {
          const intervalGroup = this.createIntervalGroup();
          intervalGroup.patchValue({
            day: interval.day || 1,
            time: interval.time || '',
            description: interval.description || '',
            conditionType: interval.conditionType !== undefined ? interval.conditionType : 1
          });
          this.intervalsArray.push(intervalGroup);
        });
      }
    }

    // 1. Populate physical evaluations with API data
    if (caseData.evaluations && Array.isArray(caseData.evaluations)) {
     
      
      const physicalEvaluationsGroup = this.caseForm.get('physicalEvaluations') as FormGroup;
      
      caseData.evaluations.forEach((evaluation: any) => {
        const controlName = `evaluation_${evaluation.evaluationId}`;
        const control = physicalEvaluationsGroup.get(controlName);
        
        if (control) {
          control.setValue(evaluation.response || '');
        } else {
          
        }
      });
    }

    // 2. Populate linked orders with API data
    this.linkedOrdersArray.clear();
    if (caseData.linkedOrders && Array.isArray(caseData.linkedOrders)) {
      caseData.linkedOrders.forEach((linkedOrder: any) => {
        // Parse prerequisiteOrder if it's a JSON string, otherwise use as array
        let prerequisiteOrderArray = [];
        if (linkedOrder.prerequisiteOrder) {
          if (typeof linkedOrder.prerequisiteOrder === 'string') {
            try {
              prerequisiteOrderArray = JSON.parse(linkedOrder.prerequisiteOrder);
            } catch (e) {
              // If parsing fails, treat as single ID and convert to array
              prerequisiteOrderArray = [linkedOrder.prerequisiteOrder];
            }
          } else if (Array.isArray(linkedOrder.prerequisiteOrder)) {
            prerequisiteOrderArray = linkedOrder.prerequisiteOrder;
          } else {
            // Single value, convert to array
            prerequisiteOrderArray = [linkedOrder.prerequisiteOrder];
          }
        }

        const linkedOrderGroup = this.createLinkedOrderGroup();
        linkedOrderGroup.patchValue({
          id: linkedOrder.id || '',
          orderName: linkedOrder.orderName || '',
          orderCategory: linkedOrder.orderCategory || '',
          orderType: linkedOrder.orderType || '',
          orderDay: linkedOrder.orderDay || 0,
          orderReturnTime: linkedOrder.orderReturnTime || '',
          routineOrderReturnTime: linkedOrder.routineOrderReturnTime || '',
          name: linkedOrder.name || '',
          category_description: linkedOrder.category_description || '',
          frequencyVal: linkedOrder.frequencyVal || [],
          prerequisiteOrder: prerequisiteOrderArray,
          response: linkedOrder.response || '',
          routeUrgencyId: linkedOrder.routeUrgencyId || 0,
          routeUrgencyVal: linkedOrder.routeUrgencyVal || [],
          type: linkedOrder.type || '',
          customResponse: linkedOrder.customResponse || ''
        });
        this.linkedOrdersArray.push(linkedOrderGroup);
      });
      
      // Initialize CKEditor instances for linked orders after view updates
      setTimeout(() => {
        this.linkedOrdersArray.controls.forEach((_, index) => {
          const linkedOrderGroup = this.linkedOrdersArray.at(index);
          if (linkedOrderGroup) {
            const content = linkedOrderGroup.get('customResponse')?.value || '';
            this.initializeLinkedOrderResponseCKEditor(index, content);
          }
        });
      }, 200);
    }

   
  }

  saveCase(): void {
    if (this.caseForm.invalid) {
      this.showNotification('Please fill all required fields', 'error');
      return;
    }

    this.modalLoader = true;
    const formData = this.prepareCaseData();

  
    

    if (this.isEditingCase) {
      // Update existing case
     
      const updateData = {
        ...formData,
        case_id: this.currentCaseId
      };
      
      this.adminService.editInteractiveCase(updateData).subscribe({
        next: (response: any) => {
          this.modalLoader = false;
          if (response.success) {
            this.showNotification('Case updated successfully', 'success');
            this.closeCaseModal();
            this.loadCases(); // Reload the cases list
          } else {
            this.showNotification(response.message || 'Error updating case', 'error');
          }
        },
        error: (error) => {
          this.modalLoader = false;
         
          this.showNotification('Error updating case', 'error');
        }
      });
    } else {
      // Create new case
      this.adminService.addInteractiveCase(formData).subscribe({
        next: (response: any) => {
          this.modalLoader = false;
          if (response.success) {
            this.showNotification('Case created successfully', 'success');
            this.closeCaseModal();
            this.loadCases(); // Reload the cases list
          } else {
            this.showNotification(response.message || 'Error creating case', 'error');
          }
        },
        error: (error) => {
          this.modalLoader = false;
          console.error('Error creating case:', error);
          this.showNotification('Error creating case', 'error');
        }
      });
    }
  }

  prepareCaseData(): any {
    const formData = this.caseForm.value;
    
    // Prepare physical evaluations data
    const physicalEvaluationsData: any[] = [];
    const physicalEvaluationsForm = formData.physicalEvaluations;
    
    if (physicalEvaluationsForm) {
      this.physicalEvaluations.forEach(evaluation => {
        const response = physicalEvaluationsForm[`evaluation_${evaluation.id}`];
        if (response && response.trim()) {
          physicalEvaluationsData.push({
            evaluationId: evaluation.id.toString(),
            response: response,
            type: evaluation.type,
            duration: evaluation.duration
          });
        }
      });
    }
    
    // Prepare baseline vitals with additional case information
    const enhancedBaselineVitals = {
      ...formData.baselineVitals,
      caseDay: formData.caseDay || 1,
      caseId: this.isEditingCase ? this.currentCaseId : null, // Will be set by backend for new cases
      caseTime: formData.caseTime
    };

    

    // Get linked orders data and update customResponse from CKEditor
    const linkedOrdersData = formData.linkedOrders.map((orderData: any, index: number) => {
      // Get custom response content from CKEditor if available
      if (this.ckEditorLinkedOrderResponses[index]) {
        orderData.customResponse = this.getLinkedOrderResponseCKEditorContent(index);
      }
      return orderData;
    });

    return {
      specialty: formData.specialty,
      subSpecialty: formData.subSpecialty,
      location: formData.location,
      duration: formData.duration,
      preOrders: formData.preOrders,
      maxSimulatedTime: formData.maxSimulatedTime,
      caseTime: formData.caseTime,
      introduction: this.getCKEditorContent('introduction'),
      initialHistory: this.getCKEditorContent('history'),
      baselineVitals: enhancedBaselineVitals,
      conditions: formData.conditions,
      intervals: formData.intervals,
      physicalEvaluations: physicalEvaluationsData,
      linkedOrders: linkedOrdersData, // Use the updated linked orders data
      createdDate: new Date().toISOString()
    };
  }

  deleteCase(caseData: any): void {
    this.itemToDelete = caseData;
    
    this.showDeleteConfirmModal = true;
  }

  // Delete Confirmation
  confirmDelete(): void {
    if (!this.itemToDelete) return;

    this.modalLoader = true;
    this.deleteErrorMessage = ''; // Clear any previous error message
    
    let apiCall;
    let successMessage = '';
    let reloadMethod;

    switch (this.deleteType) {
      case 'case':
        apiCall = this.adminService.deleteInteractiveCase({ case_id: this.itemToDelete.id });
        successMessage = 'Case deleted successfully';
        reloadMethod = () => this.loadCases();
        break;
      case 'order':
        apiCall = this.adminService.deleteOrder({ data: { id: this.itemToDelete.id } });
        successMessage = 'Order deleted successfully';
        reloadMethod = () => this.loadOrders();
        break;
      case 'category':
        apiCall = this.adminService.deleteOrderCategory({ id: this.itemToDelete.id });
        successMessage = 'Category deleted successfully';
        reloadMethod = () => this.loadOrderCategories();
        break;
      case 'type':
        apiCall = this.adminService.deleteOrderType({ id: this.itemToDelete.id });
        successMessage = 'Type deleted successfully';
        reloadMethod = () => this.loadOrderTypes();
        break;
      default:
        this.modalLoader = false;
        return;
    }

    apiCall.subscribe({
      next: (response: any) => {
        if (response.success) {
          this.showNotification(successMessage, 'success');
          this.showDeleteConfirmModal = false;
          reloadMethod();
        } else {
          // Handle specific error messages for category and type deletions
          const errorMessage = response.message || 'Error deleting item';
          
          if (this.deleteType === 'category' && errorMessage.includes('Cannot delete category. There are orders using this category.')) {
            this.deleteErrorMessage = 'Cannot delete category. There are orders using this category.';
          } else if (this.deleteType === 'type' && errorMessage.includes('Cannot delete type. There are orders using this type.')) {
            this.deleteErrorMessage = 'Cannot delete type. There are orders using this type.';
          } else {
            this.deleteErrorMessage = errorMessage;
          }
        }
        this.modalLoader = false;
      },
      error: (error) => {
        console.error('Error deleting item:', error);
        
        // Handle specific error messages from error response
        let errorMessage = 'Error deleting item';
        if (error.error && error.error.message) {
          errorMessage = error.error.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        if (this.deleteType === 'category' && errorMessage.includes('Cannot delete category. There are orders using this category.')) {
          this.deleteErrorMessage = 'Cannot delete category. There are orders using this category.';
        } else if (this.deleteType === 'type' && errorMessage.includes('Cannot delete type. There are orders using this type.')) {
          this.deleteErrorMessage = 'Cannot delete type. There are orders using this type.';
        } else {
          this.deleteErrorMessage = errorMessage;
        }
        
        this.modalLoader = false;
      }
    });
  }

  closeDeleteModal(): void {
    this.showDeleteConfirmModal = false;
    this.itemToDelete = null;
    this.deleteErrorMessage = '';
    this.modalLoader = false;
  }

  closeCaseModal(): void {
    this.showCaseModal = false;
    this.isCaseModalOpen = false;
    this.isEditingCase = false;
    this.currentCaseId = '';
    this.resetCaseForm();
    this.destroyCKEditorInstances();
    this.destroyLinkedOrderResponseCKEditors(); // Add cleanup for linked order CKEditors
  }

  resetCaseForm(): void {
    this.caseForm.reset();
    this.initializeCaseForm();
    // Reinitialize physical evaluation controls if they exist
    if (this.physicalEvaluations.length > 0) {
      this.initializePhysicalEvaluationControls();
    }
    // Clear linked orders array
    this.linkedOrdersArray.clear();
    // Clear intervals array
    this.intervalsArray.clear();
    // Clean up linked order CKEditor instances
    this.destroyLinkedOrderResponseCKEditors();
  }

  // CKEditor management
  initializeCKEditors(caseData?: any): void {
    this.initializeCKEditor('introduction', caseData?.Introduction || '');
    this.initializeCKEditor('history', caseData?.past_medical_history || caseData?.initialHistory || '');
    this.initializeCKEditor('explanation', caseData?.explanation || '');
  }

  initializeCKEditor(type: 'introduction' | 'history' | 'explanation', content: string = ''): void {
    const elementId = `ck-editor-${type}`;
    const element = document.getElementById(elementId);
    
    if (element) {
      Editor.create(element, {
        toolbar: [
          'heading', '|',
          'bold', 'italic', 'underline', '|',
          'bulletedList', 'numberedList', '|',
          'outdent', 'indent', '|',
          'blockQuote', 'insertTable', '|',
          'undo', 'redo'
        ]
      }).then((editor: any) => {
        editor.setData(content);
        
        if (type === 'introduction') {
          this.ckEditorIntroduction = editor;
        } else if (type === 'history') {
          this.ckEditorHistory = editor;
        } else if (type === 'explanation') {
          this.ckEditorExplanation = editor;
        }
      }).catch((error: any) => {
        console.error('CKEditor initialization error:', error);
      });
    }
  }

  getCKEditorContent(type: 'introduction' | 'history' | 'explanation'): string {
    if (type === 'introduction' && this.ckEditorIntroduction) {
      return this.ckEditorIntroduction.getData();
    } else if (type === 'history' && this.ckEditorHistory) {
      return this.ckEditorHistory.getData();
    } else if (type === 'explanation' && this.ckEditorExplanation) {
      return this.ckEditorExplanation.getData();
    }
    return '';
  }

  destroyCKEditorInstances(): void {
    if (this.ckEditorIntroduction && this.ckEditorIntroduction.state !== 'destroyed') {
      this.ckEditorIntroduction.destroy();
    }
    if (this.ckEditorHistory && this.ckEditorHistory.state !== 'destroyed') {
      this.ckEditorHistory.destroy();
    }
    if (this.ckEditorExplanation && this.ckEditorExplanation.state !== 'destroyed') {
      this.ckEditorExplanation.destroy();
    }
    if (this.ckEditorOrderResponse && this.ckEditorOrderResponse.state !== 'destroyed') {
      this.ckEditorOrderResponse.destroy();
    }
  }

  // Utility methods
  filterCases(): void {
    if (!this.searchTerm.trim()) {
      this.filteredCases = this.cases;
    } else {
      this.filteredCases = this.cases.filter(caseItem =>
        caseItem.specialty?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        caseItem.sub_specialty?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        caseItem.location?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        caseItem.case_id?.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    }
  }

  showNotification(message: string, type: 'success' | 'error'): void {
    this.notification = {
      show: true,
      message,
      type
    };

    // Auto hide after 5 seconds
    setTimeout(() => {
      this.hideNotification();
    }, 5000);
  }

  hideNotification(): void {
    this.notification.show = false;
  }

  // BMI calculation
  calculateBMI(): void {
    const vitals = this.caseForm.get('baselineVitals');
    const height = vitals?.get('height')?.value;
    const weight = vitals?.get('weight')?.value;
    
    if (height && weight) {
      const heightInMeters = height / 100;
      const bmi = weight / (heightInMeters * heightInMeters);
      vitals?.get('bmi')?.setValue(Math.round(bmi * 10) / 10);
    }
  }

  // Order Management Methods
  switchOrderTab(tab: 'orders' | 'categories' | 'types'): void {
    this.orderActiveTab = tab;
  }

  // Order CRUD Operations
  openOrderModal(type: 'add' | 'edit', orderData?: any): void {

    this.orderModalType = type;
    this.showOrderModal = true;
    
    console.log('1178',orderData)
    if (type === 'edit' && orderData) {
      this.currentOrderId = orderData.id;

      // Determine routeUrgencyType from routeUrgencyId if not set
      let routeUrgencyType = 0;
      if (orderData.routeUrgencyId ) {
        if (orderData.routeUrgencyId  == 1) {
          routeUrgencyType = 1; // Route
        } else if (orderData.routeUrgencyId == 2) {
          routeUrgencyType = 2; // Urgency
        }
      }

      // Parse prerequisiteOrder if it's a JSON string, otherwise use as array
      let prerequisiteOrderArray = [];
      if (orderData.prerequisiteOrder) {
        if (typeof orderData.prerequisiteOrder === 'string') {
          try {
            prerequisiteOrderArray = JSON.parse(orderData.prerequisiteOrder);
          } catch (e) {
            // If parsing fails, treat as single ID and convert to array
            prerequisiteOrderArray = [orderData.prerequisiteOrder];
          }
        } else if (Array.isArray(orderData.prerequisiteOrder)) {
          prerequisiteOrderArray = orderData.prerequisiteOrder;
        } else {
          // Single value, convert to array
          prerequisiteOrderArray = [orderData.prerequisiteOrder];
        }
      }

      this.orderForm.patchValue({
        orderName: orderData.orderName,
        orderCategory: orderData.orderCategory,
        orderType: orderData.orderType,
        frequencyVal: orderData.frequencyVal || [],
        response: orderData.response || '',
        prerequisiteOrder: prerequisiteOrderArray,
        routeUrgencyType: routeUrgencyType,
        routeUrgencyId: orderData.routeUrgencyId || 0,
        routeUrgencyVal: orderData.routeUrgencyVal || [],
        orderDay: orderData.orderDay || 0,
        orderReturnTime: orderData.orderReturnTime || '',
        routineOrderReturnTime: orderData.routineOrderReturnTime || ''
      });

      
      
      // Initialize Route/Urgency dropdowns for editing
      this.initializeRouteUrgencyDropdowns({
        ...orderData,
        routeUrgencyType: routeUrgencyType
      });

      // Parse and initialize return time
      this.parseReturnTime(orderData.orderReturnTime || '');
      this.showTimeSpinners = true;
      
      // Parse and initialize routine return time
      this.parseRoutineReturnTime(orderData.routineOrderReturnTime || '');
      
      this.loadPrerequisiteOrders(orderData.id);

      // Initialize CKEditor for response field with existing content
      setTimeout(() => {
        this.initializeOrderResponseCKEditor(orderData.response || '');
      }, 100);
    } else {
      this.currentOrderId = '';
      this.orderForm.reset();
      
      // Reset dropdown state for new order
      this.selectedRouteUrgType = 0;
      this.showSecondaryDropdown = false;
      this.secondaryDropdownLabel = '';
      this.secondaryDropdownOptions = [];

      // Reset simulation time for new order
      this.simulationTime = { days: 0, hours: 0, minutes: 0 };
      this.updateCurrentDayOfWeek();
      this.showTimeSpinners = true;

      // Reset routine simulation time for new order
      this.routineSimulationTime = { days: 0, hours: 0, minutes: 0 };

      this.loadPrerequisiteOrders();

      // Initialize CKEditor for response field (empty)
      setTimeout(() => {
        this.initializeOrderResponseCKEditor('');
      }, 100);
    }
  }

  saveOrder(): void {
    if (this.orderForm.invalid) {
      this.showNotification('Please fill all required fields', 'error');
      return;
    }

    this.modalLoader = true;
    const formData = this.orderForm.value;
    
    // Get response content from CKEditor
    if (this.ckEditorOrderResponse) {
      formData.response = this.ckEditorOrderResponse.getData();
    }
    
    // Convert arrays to JSON strings for storage
    formData.routeUrgencyVal = JSON.stringify(formData.routeUrgencyVal);
    formData.frequencyVal = JSON.stringify(formData.frequencyVal);
    formData.prerequisiteOrder = JSON.stringify(formData.prerequisiteOrder);

    if (this.orderModalType === 'edit') {
      const updateData = { ...formData, id: this.currentOrderId };
      this.adminService.editOrder(updateData).subscribe({
        next: (response: any) => {
          this.modalLoader = false;
          if (response.success) {
            this.showNotification('Order updated successfully', 'success');
            this.closeOrderModal();
            this.loadOrders();
          } else {
            this.showNotification(response.message || 'Error updating order', 'error');
          }
        },
        error: (error) => {
          this.modalLoader = false;
          console.error('Error updating order:', error);
          this.showNotification('Error updating order', 'error');
        }
      });
    } else {
      this.adminService.addOrder({ data: formData }).subscribe({
        next: (response: any) => {
          this.modalLoader = false;
          if (response.success) {
            this.showNotification('Order created successfully', 'success');
            this.closeOrderModal();
            this.loadOrders();
          } else {
            this.showNotification(response.message || 'Error creating order', 'error');
          }
        },
        error: (error) => {
          this.modalLoader = false;
          console.error('Error creating order:', error);
          this.showNotification('Error creating order', 'error');
        }
      });
    }
  }

  deleteOrder(orderData: any): void {
    this.deleteType = 'order';
    this.itemToDelete = orderData;
    this.showDeleteConfirmModal = true;
  }

  closeOrderModal(): void {
    this.showOrderModal = false;
    this.orderForm.reset();
    this.currentOrderId = '';
    
    // Destroy CKEditor instance for response
    if (this.ckEditorOrderResponse && this.ckEditorOrderResponse.state !== 'destroyed') {
      this.ckEditorOrderResponse.destroy();
      this.ckEditorOrderResponse = null;
    }
    
    // Reset dropdown state
    this.selectedRouteUrgType = 0;
    this.showSecondaryDropdown = false;
    this.secondaryDropdownLabel = '';
    this.secondaryDropdownOptions = [];

    // Reset simulation time state
    this.simulationTime = { days: 0, hours: 0, minutes: 0 };
    this.currentDayOfWeek = '';
    this.showTimeSpinners = false;

    // Reset routine simulation time state
    this.routineSimulationTime = { days: 0, hours: 0, minutes: 0 };
  }

  // Category CRUD Operations
  openCategoryModal(type: 'add' | 'edit', categoryData?: any): void {
    this.categoryModalType = type;
    this.showCategoryModal = true;
    
    if (type === 'edit' && categoryData) {
      this.currentCategoryId = categoryData.id;
      this.categoryForm.patchValue({
        name: categoryData.name
      });
    } else {
      this.currentCategoryId = '';
      this.categoryForm.reset();
    }
  }

  saveCategory(): void {
    if (this.categoryForm.invalid) {
      this.showNotification('Please fill all required fields', 'error');
      return;
    }

    this.modalLoader = true;
    const formData = this.categoryForm.value;

    if (this.categoryModalType === 'edit') {
      const updateData = { ...formData, id: this.currentCategoryId };
      this.adminService.editOrderCategory(updateData).subscribe({
        next: (response: any) => {
          this.modalLoader = false;
          if (response.success) {
            this.showNotification('Category updated successfully', 'success');
            this.closeCategoryModal();
            this.loadOrderCategories();
          } else {
            this.showNotification(response.message || 'Error updating category', 'error');
          }
        },
        error: (error) => {
          this.modalLoader = false;
          console.error('Error updating category:', error);
          this.showNotification('Error updating category', 'error');
        }
      });
    } else {
      this.adminService.addOrderCategory(formData).subscribe({
        next: (response: any) => {
          this.modalLoader = false;
          if (response.success) {
            this.showNotification('Category created successfully', 'success');
            this.closeCategoryModal();
            this.loadOrderCategories();
          } else {
            this.showNotification(response.message || 'Error creating category', 'error');
          }
        },
        error: (error) => {
          this.modalLoader = false;
          console.error('Error creating category:', error);
          this.showNotification('Error creating category', 'error');
        }
      });
    }
  }

  deleteCategory(categoryData: any): void {
    this.deleteType = 'category';
    this.itemToDelete = categoryData;
    this.showDeleteConfirmModal = true;
  }

  closeCategoryModal(): void {
    this.showCategoryModal = false;
    this.categoryForm.reset();
    this.currentCategoryId = '';
  }

  // Type CRUD Operations
  openTypeModal(type: 'add' | 'edit', typeData?: any): void {
    this.typeModalType = type;
    this.showTypeModal = true;
    
    if (type === 'edit' && typeData) {
      this.currentTypeId = typeData.id;
      this.typeForm.patchValue({
        type: typeData.type
      });
    } else {
      this.currentTypeId = '';
      this.typeForm.reset();
    }
  }

  saveType(): void {
    if (this.typeForm.invalid) {
      this.showNotification('Please fill all required fields', 'error');
      return;
    }

    this.modalLoader = true;
    const formData = this.typeForm.value;

    if (this.typeModalType === 'edit') {
      const updateData = { ...formData, id: this.currentTypeId };
      this.adminService.editOrderType(updateData).subscribe({
        next: (response: any) => {
          this.modalLoader = false;
          if (response.success) {
            this.showNotification('Type updated successfully', 'success');
            this.closeTypeModal();
            this.loadOrderTypes();
          } else {
            this.showNotification(response.message || 'Error updating type', 'error');
          }
        },
        error: (error) => {
          this.modalLoader = false;
          console.error('Error updating type:', error);
          this.showNotification('Error updating type', 'error');
        }
      });
    } else {
      this.adminService.addOrderType(formData).subscribe({
        next: (response: any) => {
          this.modalLoader = false;
          if (response.success) {
            this.showNotification('Type created successfully', 'success');
            this.closeTypeModal();
            this.loadOrderTypes();
          } else {
            this.showNotification(response.message || 'Error creating type', 'error');
          }
        },
        error: (error) => {
          this.modalLoader = false;
          console.error('Error creating type:', error);
          this.showNotification('Error creating type', 'error');
        }
      });
    }
  }

  deleteOrderType(typeData: any): void {
    this.deleteType = 'type';
    this.itemToDelete = typeData;
    this.showDeleteConfirmModal = true;
  }

  closeTypeModal(): void {
    this.showTypeModal = false;
    this.typeForm.reset();
    this.currentTypeId = '';
  }

  // Load prerequisite orders (excluding current order for edit)
  loadPrerequisiteOrders(excludeOrderId?: string): void {
    this.adminService.getOrdersForPrerequisite(excludeOrderId).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.prerequisiteOrders = response.data;
        }
      },
      error: (error) => {
        console.error('Error loading prerequisite orders:', error);
      }
    });
  }

  // Filter orders
  filterOrders(): void {
    if (!this.orderSearchTerm.trim()) {
      this.filteredOrders = this.orders;
    } else {
      this.filteredOrders = this.orders.filter(order =>
        order.orderName?.toLowerCase().includes(this.orderSearchTerm.toLowerCase()) ||
        order.categoryName?.toLowerCase().includes(this.orderSearchTerm.toLowerCase()) ||
        order.typeName?.toLowerCase().includes(this.orderSearchTerm.toLowerCase())
      );
    }

    console.log(this.filteredOrders)
  }

  // Prevent modal from closing when clicking on form elements
  preventModalClose(event: Event): void {
    // Only prevent modal close for specific form elements, not for multiselect dropdowns
    const target = event.target as HTMLElement;
    
    // Don't prevent propagation for multiselect related elements
    if (target && (
      target.closest('.p-multiselect') ||
      target.closest('.p-multiselect-panel') ||
      target.closest('.p-multiselect-items') ||
      target.classList.contains('p-multiselect-token') ||
      target.classList.contains('p-multiselect-trigger')
    )) {
      return;
    }
    
    // Prevent modal close for other form elements
    event.stopPropagation();
  }
  
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      if (this.showExplanationModal) {
        this.closeExplanationModal();
      }
    }
  }
  
  // =====================================================
  // EXPLANATION MODAL METHODS
  // =====================================================
  
  openExplanationModal(caseData: any): void {
    
    this.currentExplanationCase = caseData;
    this.showExplanationModal = true;
    
    // Check if explanation exists
    if (caseData.explanation || caseData.scoring || caseData.clock_management) {
      this.explanationModalType = 'edit';
    } else {
      this.explanationModalType = 'add';
    }
    
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
    
    // Initialize CKEditors after modal is shown
    setTimeout(() => {
      this.initializeExplanationCKEditors(caseData);
      // Focus the first editor for accessibility
      const firstEditor = document.getElementById('approachEditor');
      if (firstEditor) {
        firstEditor.focus();
      }
    }, 100);
  }
  
  closeExplanationModal(): void {
    this.showExplanationModal = false;
    this.currentExplanationCase = null;
    this.destroyExplanationCKEditors();
    this.explanationForm.reset();
    
    // Restore body scroll
    document.body.style.overflow = 'auto';
  }
  
  initializeExplanationCKEditors(caseData?: any): void {
    // Initialize Approach Editor
    this.initializeExplanationCKEditor('approach', caseData?.explanation || '');
    
    // Initialize Scoring Editor
    this.initializeExplanationCKEditor('scoring', caseData?.scoring || '');
    
    // Initialize Clock Management Editor
    this.initializeExplanationCKEditor('clockManagement', caseData?.clock_management || '');
  }
  
  initializeExplanationCKEditor(type: 'approach' | 'scoring' | 'clockManagement', content: string = ''): void {
    const editorId = type === 'approach' ? 'approachEditor' : 
                     type === 'scoring' ? 'scoringEditor' : 'clockManagementEditor';
    
    const element = document.getElementById(editorId);
    if (element) {
      Editor.create(element, {
        toolbar: [
          'heading', '|',
          'bold', 'italic', 'underline', '|',
          'bulletedList', 'numberedList', '|',
          'outdent', 'indent', '|',
          'link', 'blockQuote', 'insertTable', '|',
          'undo', 'redo'
        ],
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
          ]
        }
      })
      .then((editor: any) => {
        editor.setData(content);
        
        // Store editor instance
        if (type === 'approach') {
          this.ckEditorApproach = editor;
        } else if (type === 'scoring') {
          this.ckEditorScoring = editor;
        } else if (type === 'clockManagement') {
          this.ckEditorClockManagement = editor;
        }
      })
      .catch((error: any) => {
        console.error('Error initializing CKEditor for ' + type + ':', error);
      });
    }
  }
  
  getExplanationCKEditorContent(type: 'approach' | 'scoring' | 'clockManagement'): string {
    if (type === 'approach' && this.ckEditorApproach) {
      return this.ckEditorApproach.getData();
    } else if (type === 'scoring' && this.ckEditorScoring) {
      return this.ckEditorScoring.getData();
    } else if (type === 'clockManagement' && this.ckEditorClockManagement) {
      return this.ckEditorClockManagement.getData();
    }
    return '';
  }
  
  destroyExplanationCKEditors(): void {
    if (this.ckEditorApproach) {
      this.ckEditorApproach.destroy()
        .then(() => {
          this.ckEditorApproach = null;
        })
        .catch((error: any) => console.error('Error destroying approach editor:', error));
    }
    
    if (this.ckEditorScoring) {
      this.ckEditorScoring.destroy()
        .then(() => {
          this.ckEditorScoring = null;
        })
        .catch((error: any) => console.error('Error destroying scoring editor:', error));
    }
    
    if (this.ckEditorClockManagement) {
      this.ckEditorClockManagement.destroy()
        .then(() => {
          this.ckEditorClockManagement = null;
        })
        .catch((error: any) => console.error('Error destroying clock management editor:', error));
    }
  }
  
  saveExplanation(): void {
    if (this.explanationForm.invalid) {
      this.showNotification('Please fill all required fields', 'error');
      return;
    }

    this.modalLoader = true;
    const formData = this.explanationForm.value;

    // Get content from CKEditor instances
    const approach = this.getExplanationCKEditorContent('approach');
    const scoring = this.getExplanationCKEditorContent('scoring');
    const clockManagement = this.getExplanationCKEditorContent('clockManagement');

    // Prepare explanation data
    const explanationData = {
      id: this.currentExplanationCase.id,
      approach: approach,
      scoring: scoring,
      clockManagement: clockManagement
    };

    this.adminService.editCaseExplanation(explanationData).subscribe({
      next: (response: any) => {
        this.modalLoader = false;
        if (response.success) {
          this.showNotification('Explanation updated successfully', 'success');
          this.closeExplanationModal();
          this.loadCases();
        } else {
          this.showNotification(response.message || 'Error updating explanation', 'error');
        }
      },
      error: (error) => {
        this.modalLoader = false;
        console.error('Error updating explanation:', error);
        this.showNotification('Error updating explanation', 'error');
      }
    });
  }

  // Return Time simulation methods (similar to launch-case component)
  onDayChange(value: string): void {
    const days = parseInt(value) || 0;
    this.simulationTime.days = Math.max(0, Math.min(999, days));
    this.updateCurrentDayOfWeek();
    this.updateReturnTimeForm();
  }

  onHourChange(value: string): void {
    const hours = parseInt(value) || 0;
    this.simulationTime.hours = Math.max(0, Math.min(23, hours));
    this.updateCurrentDayOfWeek();
    this.updateReturnTimeForm();
  }

  onMinuteChange(value: string): void {
    const minutes = parseInt(value) || 0;
    this.simulationTime.minutes = Math.max(0, Math.min(59, minutes));
    this.updateCurrentDayOfWeek();
    this.updateReturnTimeForm();
  }

  // Routine Return Time simulation methods
  onRoutineDayChange(value: string): void {
    const days = parseInt(value) || 0;
    this.routineSimulationTime.days = Math.max(0, Math.min(999, days));
    this.updateRoutineReturnTimeForm();
  }

  onRoutineHourChange(value: string): void {
    const hours = parseInt(value) || 0;
    this.routineSimulationTime.hours = Math.max(0, Math.min(23, hours));
    this.updateRoutineReturnTimeForm();
  }

  onRoutineMinuteChange(value: string): void {
    const minutes = parseInt(value) || 0;
    this.routineSimulationTime.minutes = Math.max(0, Math.min(59, minutes));
    this.updateRoutineReturnTimeForm();
  }

  updateCurrentDayOfWeek(): void {
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const today = new Date();
    const futureDate = new Date(today.getTime() + (this.simulationTime.days * 24 * 60 * 60 * 1000));
    this.currentDayOfWeek = daysOfWeek[futureDate.getDay()];
  }

  updateReturnTimeForm(): void {
    // Update the form with JSON stringified time data
    const timeData = {
      days: this.simulationTime.days,
      hours: this.simulationTime.hours,
      minutes: this.simulationTime.minutes
    };
    this.orderForm.patchValue({
      orderReturnTime: JSON.stringify(timeData)
    });
  }

  updateRoutineReturnTimeForm(): void {
    // Update the form with JSON stringified time data
    const timeData = {
      days: this.routineSimulationTime.days,
      hours: this.routineSimulationTime.hours,
      minutes: this.routineSimulationTime.minutes
    };
    this.orderForm.patchValue({
      routineOrderReturnTime: JSON.stringify(timeData)
    });
  }

  parseReturnTime(returnTimeString: string): void {
    if (!returnTimeString) {
      this.simulationTime = { days: 0, hours: 0, minutes: 0 };
      this.updateCurrentDayOfWeek();
      return;
    }

    try {
      // Try to parse as JSON first (new format)
      const timeData = JSON.parse(returnTimeString);
      if (timeData.days !== undefined && timeData.hours !== undefined && timeData.minutes !== undefined) {
        this.simulationTime = {
          days: timeData.days || 0,
          hours: timeData.hours || 0,
          minutes: timeData.minutes || 0
        };
      } else {
        // Handle old format (string like "1200")
        this.parseOldReturnTimeFormat(returnTimeString);
      }
    } catch (error) {
      // Handle old format (string like "1200")
      this.parseOldReturnTimeFormat(returnTimeString);
    }
    this.updateCurrentDayOfWeek();
  }

  parseOldReturnTimeFormat(returnTimeString: string): void {
    // Parse old format like "1200" as hours and minutes
    if (returnTimeString.length >= 2) {
      const hours = parseInt(returnTimeString.substring(0, 2)) || 0;
      const minutes = returnTimeString.length >= 4 ? 
        parseInt(returnTimeString.substring(2, 4)) || 0 : 0;
      
      this.simulationTime = {
        days: 0,
        hours: Math.max(0, Math.min(23, hours)),
        minutes: Math.max(0, Math.min(59, minutes))
      };
    } else {
      this.simulationTime = { days: 0, hours: 0, minutes: 0 };
    }
  }

  parseRoutineReturnTime(returnTimeString: string): void {
    if (!returnTimeString) {
      this.routineSimulationTime = { days: 0, hours: 0, minutes: 0 };
      return;
    }

    try {
      // Try to parse as JSON first (new format)
      const timeData = JSON.parse(returnTimeString);
      if (timeData.days !== undefined && timeData.hours !== undefined && timeData.minutes !== undefined) {
        this.routineSimulationTime = {
          days: timeData.days || 0,
          hours: timeData.hours || 0,
          minutes: timeData.minutes || 0
        };
      } else {
        // Handle old format (string like "1200")
        this.parseOldRoutineReturnTimeFormat(returnTimeString);
      }
    } catch (error) {
      // Handle old format (string like "1200")
      this.parseOldRoutineReturnTimeFormat(returnTimeString);
    }
  }

  parseOldRoutineReturnTimeFormat(returnTimeString: string): void {
    // Parse old format like "1200" as hours and minutes
    if (returnTimeString.length >= 2) {
      const hours = parseInt(returnTimeString.substring(0, 2)) || 0;
      const minutes = returnTimeString.length >= 4 ? 
        parseInt(returnTimeString.substring(2, 4)) || 0 : 0;
      
      this.routineSimulationTime = {
        days: 0,
        hours: Math.max(0, Math.min(23, hours)),
        minutes: Math.max(0, Math.min(59, minutes))
      };
    } else {
      this.routineSimulationTime = { days: 0, hours: 0, minutes: 0 };
    }
  }

  // Initialize CKEditor for response field
  initializeOrderResponseCKEditor(content: string): void {
    const element = document.getElementById('responseEditor');
    if (element) {
      Editor.create(element, {
        toolbar: [
          'bold', 'italic', 'underline', '|',
          'bulletedList', 'numberedList', '|',
          'outdent', 'indent', '|',
          'link', 'blockQuote', 'insertTable', '|',
          'undo', 'redo'
        ]
      }).then((editor: any) => {
        editor.setData(content);
        this.ckEditorOrderResponse = editor;
      }).catch((error: any) => {
        console.error('Error initializing response editor:', error);
      });
    }
  }

  // Initialize CKEditor for linked order custom response
  initializeLinkedOrderResponseCKEditor(orderIndex: number, content: string = ''): void {
    const elementId = `linkedOrderResponseEditor_${orderIndex}`;
    const element = document.getElementById(elementId);
    
    if (element) {
      // Destroy existing editor instance if it exists
      if (this.ckEditorLinkedOrderResponses[orderIndex]) {
        this.ckEditorLinkedOrderResponses[orderIndex].destroy();
        this.ckEditorLinkedOrderResponses[orderIndex] = null;
      }

      Editor.create(element, {
        toolbar: [
          'bold', 'italic', 'underline', '|',
          'bulletedList', 'numberedList', '|',
          'outdent', 'indent', '|',
          'link', 'blockQuote', 'insertTable', '|',
          'undo', 'redo'
        ]
      }).then((editor: any) => {
        editor.setData(content);
        this.ckEditorLinkedOrderResponses[orderIndex] = editor;
        
        // Update form control when editor content changes
        editor.model.document.on('change:data', () => {
          const linkedOrderGroup = this.linkedOrdersArray.at(orderIndex);
          if (linkedOrderGroup) {
            linkedOrderGroup.get('customResponse')?.setValue(editor.getData(), { emitEvent: false });
          }
        });
        
        console.log(`CKEditor initialized for linked order ${orderIndex}`);
      }).catch((error: any) => {
        console.error(`Error initializing linked order response editor ${orderIndex}:`, error);
      });
    } else {
      console.error(`Element with ID ${elementId} not found`);
      // Add to pending initializations if element not found
      this.pendingCKEditorInitializations.add(orderIndex);
    }
  }

  // Get content from linked order CKEditor
  getLinkedOrderResponseCKEditorContent(orderIndex: number): string {
    if (this.ckEditorLinkedOrderResponses[orderIndex]) {
      return this.ckEditorLinkedOrderResponses[orderIndex].getData();
    }
    return '';
  }

  // Destroy all linked order CKEditor instances
  destroyLinkedOrderResponseCKEditors(): void {
    this.ckEditorLinkedOrderResponses.forEach((editor, index) => {
      if (editor && editor.state !== 'destroyed') {
        try {
          editor.destroy();
        } catch (error) {
          console.error(`Error destroying linked order CKEditor ${index}:`, error);
        }
      }
    });
    this.ckEditorLinkedOrderResponses = [];
    this.pendingCKEditorInitializations.clear();
  }

  // Initialize pending CKEditor instances (called after view updates)
  initializePendingCKEditors(): void {
    const pendingIndexes = Array.from(this.pendingCKEditorInitializations);
    this.pendingCKEditorInitializations.clear();
    
    pendingIndexes.forEach(orderIndex => {
      const linkedOrderGroup = this.linkedOrdersArray.at(orderIndex);
      if (linkedOrderGroup) {
        const content = linkedOrderGroup.get('customResponse')?.value || '';
        this.initializeLinkedOrderResponseCKEditor(orderIndex, content);
      }
    });
  }
} 